export default "__VITE_ASSET__DnqjT3ee__"